export default "__VITE_ASSET__C9OJF7v$__"